import React from 'react';
import {
    Box,
    Link,
    Typography,
} from '@mui/material';
import { NavLink } from "react-router-dom";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <Box sx={{
                p:2,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
            <Box sx={{
                display: 'flex',
                gap: 2,
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Link component={NavLink} to="/terms" underline='hover'>
                    Terms
                </Link >
                <Link component={NavLink} to="/privacy" underline='hover'>
                    Privacy
                </Link >
            </Box>
            <Typography variant='caption' sx={{mt: 2}}>
                © {currentYear} PR Innova Inc.® All rights reserved.
            </Typography>
        </Box>
    );
}